import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Beacon, BeaconSensorEvent } from "../../../api/models";
import { BaseDrawer } from "../../BaseDrawer";
import { Chart, SeriesDefinition } from "../../chart/Chart";
import { DownloadEnvironmentMessages } from "../../DownloadEnvironmentMessages";
interface BeaconBatteryDrawerProps {
  beaconId: Beacon["beaconId"];
  environmentHistory: BeaconSensorEvent[];
  environmentHistoryIsLoading: boolean;
  environmentFromToDateRange: {
    from: Date;
    to: Date;
  };
  seriesDefintions: SeriesDefinition;
  batteryDrawerVisible: boolean;
  onCloseDrawer: (visible: boolean) => void;
}

export function BeaconBatteryDrawer({
  beaconId,
  environmentHistory,
  environmentHistoryIsLoading,
  environmentFromToDateRange,
  seriesDefintions,
  batteryDrawerVisible,
  onCloseDrawer,
}: BeaconBatteryDrawerProps) {
  const { t } = useTranslation();
  const [renderChart, setRenderChart] = useState(false);

  const closeDrawer = () => {
    onCloseDrawer(false);
  };

  return (
    <BaseDrawer
      title={t("battery-voltage")}
      drawerVisible={batteryDrawerVisible}
      onCloseDrawer={closeDrawer}
      afterOpenChange={(open) => setRenderChart(open)}
      dataTestId="beacon-battery-drawer"
    >
      {renderChart && (
        <Chart
          seriesDefintions={[seriesDefintions]}
          isLoading={environmentHistoryIsLoading}
        />
      )}
      {!!environmentHistory?.length && (
        <DownloadEnvironmentMessages
          beaconId={beaconId}
          environmentMessages={environmentHistory || []}
          style={{ position: "absolute", bottom: 10, right: 40 }}
          from={environmentFromToDateRange.from}
          to={environmentFromToDateRange.to}
        />
      )}
    </BaseDrawer>
  );
}
